import React, { useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useForm, Controller } from "react-hook-form";
import { TextField, FormHelperText, Button, FormControl } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import GooglePlaceAutoComplete, { PlaceDetails } from '../../shared/GooglePlaceAutoComplete';
import { useState } from 'react';
import { consts } from '../../../common/consts';
import api from '../../../store/api';
import Link from '@material-ui/core/Link';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import submitData from '../submitData';
import { SelectItem } from './OriginDestination'
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { getDataFromStorage } from "../../../common/sessionStorageHelpers"
import { persistName } from "../../Schedule/helpers/transferScheduleHelpers";
import { useHistory } from "react-router-dom";
import AcuityPopup from "../../patientCareRecord/SubFormWidgets/Popups/AcuityPopup";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";

export interface SpecialNeed {
    specialNeedId: string,
    name: string,
    selected: boolean,
    iconUrl: string
}

const useStyles = makeStyles((theme) => ({
    root: {
        wordBreak: 'break-word'
    },
    formControlLabel: {
        fontSize: 18,
        color: '#4A4A4A',
        padding: theme.spacing(0, 0, 1, 0)

    },
    helpText: {
        color: 'red',
        padding: theme.spacing(0, 0, 0, 2)
    },
    hide: {
        display: 'none'
    },
    show: {
        display: 'inline'
    },
    fixedTop: {
        position: "fixed",
        width:'calc(100vw - 330px)',
        backgroundColor: "white",
        zIndex: 9,
        height: 130,
        paddingTop:40
    },
    dropdownIcon: {
        top:4
    }
}));

const HorizontalLine = (props: any) => {
    return (
        <hr
            style={{
                border: 0,
                borderTop: '1px solid #DADADA',
            }}
        />
    )
}

const AmbulantIcon = (props: any) => {
    return (
        <div style={{ display: 'inline-block' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="97" height="28" viewBox="0 0 97 8">
                <text id="Ambulant" transform="translate(20 18)" fill="#333" fontSize="18" fontFamily="Lato-Regular, Lato"><tspan x="0" y="0">Ambulant</tspan></text>
                <path id="Combined_Shape" data-name="Combined Shape" d="M8.138,17.582l-5.05-6.864A1.492,1.492,0,0,1,2.806,9.5l.485-3.016-1.177.839-.442,2.743a.837.837,0,0,1-.83.7.818.818,0,0,1-.132-.01.827.827,0,0,1-.7-.945l.5-3.081a.822.822,0,0,1,.337-.539L3.269,4.462A2.4,2.4,0,0,1,5.033,3.9a2.027,2.027,0,0,1,1.728,2.14c0,.057-.01.113-.019.169l-.8,4.94L9.806,16.4a1,1,0,0,1-.231,1.409,1.043,1.043,0,0,1-1.436-.228ZM2.2,17.809A1,1,0,0,1,1.97,16.4l2.188-2.975,1.268,1.723L3.637,17.582a1.042,1.042,0,0,1-1.436.228ZM7.877,10.7l-.9-1.22.371-2.308L9.238,9.725a.816.816,0,0,1-.186,1.154A.852.852,0,0,1,7.877,10.7ZM3.958,1.651a1.683,1.683,0,0,1,3.365,0,1.683,1.683,0,0,1-3.365,0Z" transform="translate(0 1)" />
            </svg>
        </div>
    );
}

const NotAmbulantIcon = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="138" height="28" viewBox="0 0 138 8">
            <text id="Not_Ambulant" data-name="Not Ambulant" transform="translate(27 18)" fill="#333" fontSize="18" fontFamily="Lato-Regular, Lato"><tspan x="0" y="0">Not Ambulant</tspan></text>
            <path id="Combined_Shape" data-name="Combined Shape" d="M12.126,12.722H3.875A2,2,0,0,1,2,14a1.911,1.911,0,1,1,0-3.818,2.043,2.043,0,0,1,1.319.484L6.632,8.911,3.03,7H5.773L8,8.179,10.228,7h2.743L9.369,8.9l3.315,1.762A2.049,2.049,0,0,1,14,10.183,1.911,1.911,0,1,1,14,14,1.994,1.994,0,0,1,12.126,12.722Zm1.211-.636A.666.666,0,1,0,14,11.449.653.653,0,0,0,13.337,12.085Zm-12,0A.653.653,0,0,0,2,12.722a.637.637,0,1,0,0-1.273A.652.652,0,0,0,1.333,12.085Zm3.249-.636h6.837L8,9.636ZM.666,5.726A.651.651,0,0,1,0,5.089V3.817a.651.651,0,0,1,.666-.635H15.314a.651.651,0,0,1,.666.635V5.089a.651.651,0,0,1-.666.636ZM2,2.545a.652.652,0,0,1-.665-.636V.636A.652.652,0,0,1,2,0H4.66a.652.652,0,0,1,.666.636V1.909a.652.652,0,0,1-.666.636Z" transform="translate(0 3)" />
        </svg>
    );
}

const PatientDetails = ({ NextButton, handleData, data, saveChangesState, isEdit, dispatch }: any) => {
    const classes = useStyles();
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError, trigger } = useForm();
    const [sex, setSex] = useState('');
    const [indigenous, setIndigenous] = useState('');
    const [classification, setClassification] = useState('');
    const [grith, setGrith] = useState(false);
    const [estimateWeight, setEstimateWeight] = useState(false);
    const [ambulant, setAmbulant] = useState('');
    const [locationDefaultValue, setLocationDefaultValue] = useState('');
    const [withAssistance, setWithAssistance] = useState(false);
    const [specialNeeds, setSpecialNeeds] = useState<SpecialNeed[]>([]);
    const [warningMessage, setWarningMessage] = useState('');
    const [isAddressChanged, setIsAddressChanged] = useState(false);
    const [isSMAProfile, setIsSMAProfile] = useState(false);
    const [customerLocations, setCustomerLocations] = useState<SelectItem[]>([]);
    const history = useHistory();
    const [selectedLocaton, setSelectedLocaton] = useState('');
    const [acuityIdb, setacuityIdb] = useState<SelectItem[]>([]);
    const [acuityPopup, setAcuityPopup] = React.useState(false);
    const [isNSWLocationIdb, setisNSWLocationIdb] = useState<any>(null);
    const [isEnableAcuity, setisEnableAcuity] = useState<boolean>(false);
    const { authStore } = useSelector((state: RootState) => state);
    React.useEffect(() => {
        loadData();
    }, []);

    const loadData = async (): Promise<void> => {
        try {
            const res = await api.getLocationsForUserProfiles('');
            if (res !== null && res.data !== null && res.data.model !== null){
                const locations = res.data.model;
                if (locations.length > 0) {
                    await getLocationsData(false);
                    setIsSMAProfile(locations.length > 1);
                    const selectedLocationid = localStorage.getItem('selectedLocationsId');
                    if(selectedLocationid !=null && selectedLocationid!=''){
                        setClassifications(selectedLocationid);
                    }
                }
            }
            if(!isSMAProfile) {
                var userState = await (await api.getUserLocation(''));
                setSelectedLocaton(userState);
                if(userState !=null && userState!=undefined){
                    localStorage.setItem('selectedLocationState', userState);
                    if(userState === "NSW"){
                        setisNSWLocationIdb(true);
                    }
                    if(!IsNullorEmpty(userState)){
                        setisEnableAcuity(true)
                    }
                }
            }
            
            const selectedLocationState = localStorage.getItem('selectedLocationState');
            if(selectedLocationState!=null && selectedLocationState == undefined){
                setSelectedLocaton(selectedLocationState);
                if(selectedLocationState === "NSW"){
                    setisNSWLocationIdb(true);
                }
                if(!IsNullorEmpty(selectedLocationState)){
                    setisEnableAcuity(true)
                }
            }
            
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (locationDefaultValue) {
            setTimeout(() => setValue("patientOfLocation", locationDefaultValue), 1)
            
        }
    }, [locationDefaultValue])

    useEffect(() => {
        if (data.birthday) {
            const [yyyy, mm, dd] = data.birthday ? data.birthday.split("T")[0].split("-") : ["", "", ""];
            setValue("patientOfLocation", data.patientOfLocation !== undefined ? data.patientOfLocation.toLowerCase() || "" : "");
            setValue("firstName", data.firstname || data.firstName || "");
            setValue("lastName", data.lastname || data.lastName || "");
            setValue("bDay", dd || data.bDay || "");
            setValue("bMonth", mm || data.bMonth || "");
            setValue("bYear", yyyy || data.bYear || "");
            setValue("mrn", data.MRN || data.mrn || "");
            setValue("patientAddress", data.patientAddress || "");
            setValue("weight", data.weight || "");
            setValue("sex", data.sex || data.genderName || "");
            //setValue("classificationName", data.classificationName);
            setValue("acuity", String(data.classification));
            setValue("reasonForTransport", data.reasonForTransport);
            if (data.bookingSpecialNeeds) {
                getSpecialNeeds(data.specialNeeds, data.bookingSpecialNeeds);
            }
            if (data.BookingSpecialNeeds) {
                getSpecialNeeds(data.SpecialNeeds, data.BookingSpecialNeeds);
            }
            setAmbulant(data.mobilityName);
            setClassification(String(data.classification));
            setacuityIdb(data.classification);

            setSex(data.genderName);
            setGrith(data.GirthIsOver90CM);
            setWithAssistance(data.withAssistance);
            setEstimateWeight(data.estimateWeight);
            let indigenous = data.IsIdentifiedAsIndegennous !== undefined ? data.IsIdentifiedAsIndegennous : data.isIdentifiedAsIndegennous;
            if (indigenous !== undefined) {
                if (indigenous === 0) {
                    setIndigenous('Neither');
                    setValue("indigenous", "Neither");
                }
                if (indigenous === 1) {
                    setIndigenous('Aboriginal');
                    setValue("indigenous", "Aboriginal");
                }
                if (indigenous === 2) {
                    setIndigenous('Unspecified');
                    setValue("indigenous", "Unspecified");
                }
                if (indigenous === 3) {
                    setIndigenous('Torres Strait Islander');
                    setValue("indigenous", "Torres Strait Islander");
                }
                if (indigenous === 4) {
                    setIndigenous('Both');
                    setValue("indigenous", "Both");
                }
                
            }
            const fetchLocations = async () => {
                let customerLocations: any[] = [];
                customerLocations = await (await api.getLocationsForUserProfiles('')).data.model;
                if (customerLocations) {
                    var selectedLocation = customerLocations.filter(a => a.locationId == data.patientOfLocation)
                    if(selectedLocation != undefined) {
                        if(selectedLocation[0] != undefined) {
                            setSelectedLocaton(selectedLocation[0].state);
                            if(selectedLocation[0].state !=null && selectedLocation[0].state!=undefined){
                                localStorage.setItem('selectedLocationState', selectedLocation[0].state);
                                if(selectedLocation[0].state === "NSW"){
                                    setisNSWLocationIdb(true);
                                }
                                if(!IsNullorEmpty(selectedLocation[0]?.state)){
                                    setisEnableAcuity(true)
                                }
                            }
                        }
                    }
                }
              }

            fetchLocations().catch(console.error);
        }
    }, [data, isSMAProfile])

    const saveChanges = async (update = false) => {
        const isValid = await trigger();
        if (isValid) {
            handleData(getFormValues());
            if (update == true) submitData({ ...data, ...getFormValues() }, dispatch, history);
        }
    }

    useEffect(() => {
        if (Object.keys(data).length === 0) {
            getSpecialNeeds();
        }
    }, [])

    useEffect(() => {
        saveChangesState[1](() => saveChanges);
    }, [ambulant, withAssistance, grith, specialNeeds, data])

    const getSpecialNeeds = async (originalData?: any[], data?: any[]): Promise<void> => {
        let storeSpecialNeeds = localStorage.getItem('specialNeeds');
        if (storeSpecialNeeds)
            originalData = JSON.parse(storeSpecialNeeds ?? '');
        if (data && originalData && data.length > 0) {
            let specialNeedsArray = [...originalData];
            specialNeedsArray.forEach((item: SpecialNeed) => {
                data.forEach((id: any) => {
                    let specialId = id.SpecialNeedId ?? id.specialNeedId;
                    if (item.specialNeedId === specialId) {
                        item.selected = true;
                    }
                });
            });
            setSpecialNeeds(specialNeedsArray);
        } else {
            const _res = await api.getSpecialNeeds('');
            if (_res !== null && _res.data !== null && _res.data.model !== null) {
                const specialNeedsMap: any = {};
                _res.data.model.forEach((item: SpecialNeed) => {
                    item.selected = false;
                    specialNeedsMap[item.specialNeedId] = { name: item.name, icon: item.iconUrl };
                })
                localStorage.setItem('specialNeedsMap', JSON.stringify(specialNeedsMap));
                localStorage.setItem('specialNeeds', JSON.stringify(_res.data.model));
                setSpecialNeeds(_res.data.model);
            }
        }
    }

    const handleNext = async (data: any): Promise<void> => {
        handleData(data);
    }

    const validateDateOfBirth = () => {
        let dob = getValues('bYear') + '-' + getValues('bMonth') + '-' + getValues('bDay');
        let isValid = new Date(dob)?.getTime() ? true : false;
        if (isValid) {
            let today = new Date().toISOString().split('T')[0];
            if (new Date(dob).getTime() > new Date(today).getTime())
                isValid = false;
        }
        if (!isValid) {
            [
                {
                    type: "manual",
                    name: "bDay",
                    message: " "
                },
                {
                    type: "manual",
                    name: "bMonth",
                    message: " "
                },
                {
                    type: "manual",
                    name: "bYear",
                    message: " "
                },
            ].forEach(({ name, type, message }) =>
                setError(name, { type, message })
            );
        }
        return isValid;
    }

    const onNextButtonClick = async (): Promise<boolean> => {
        const isValid = await trigger();
        if (isValid) {
            await handleNext(getFormValues());
        }
        return isValid;
    }

    const IsOxygenIsSelected = () => {
        let items = [...specialNeeds];
        return items.some(n => n.selected === true && n.name === "Oxygen will be required on transport");
    }

    const setClassifications = async (location: any) => {
        let customerLocations: any[] = [];
        const res = await api.getLocationsForUserProfiles('');
        customerLocations = res.data.model;
        if (customerLocations) {
            var selectedLocation = customerLocations.filter(a => a.locationId == location)
            if(selectedLocation != undefined) {
                if(selectedLocation[0] != undefined) {
                    setSelectedLocaton(selectedLocation[0].state);
                    if(selectedLocation[0].state !=null && selectedLocation[0].state!=undefined){
                        localStorage.setItem('selectedLocationState', selectedLocation[0].state);
                        if(selectedLocation[0].state === "NSW"){
                            setisNSWLocationIdb(true);
                        }
                        if(!IsNullorEmpty(selectedLocation[0]?.state)){
                            setisEnableAcuity(true)
                        }
                    }
                }
            }
        }
    }

    const getFormValues = () => {
        let specialValues = getSpecialNeedId();
        let values = getValues();
        values.pgrith = grith;
        values.assistance = withAssistance;
        values.mobilityName = ambulant;
        values.specialNeeds = specialNeeds;
        values.bookingSpecialNeeds = specialValues;

        let classification = 0;
        let gender = 0;
        let indigenous = 0;

        if (values.sex === "Male")
            gender = 1;
        if (values.sex === "Female")
            gender = 2;
        if (values.sex === "Not Disclosed")
            gender = 3;

        if (values.indigenous === "Neither")
            indigenous = 0;
        if (values.indigenous === "Aboriginal")
            indigenous = 1;
        if (values.indigenous === "Unspecified")
            indigenous = 2;
        if (values.indigenous === "Torres Strait Islander")
            indigenous = 3;
        if (values.indigenous === "Both")
            indigenous = 4;
        

        let isOxygenRequired = IsOxygenIsSelected();

        var patientOfLoc = !IsNullorEmpty(values.patientOfLocation) ? values.patientOfLocation : (!IsNullorEmpty(localStorage.getItem("SelectedLocation"))
            ? localStorage.getItem("SelectedLocation") : (!IsNullorEmpty(localStorage.getItem("selectedLocationsId")) ? localStorage.getItem("selectedLocationsId") : undefined));

        let databody = {
            patientOfLocation: patientOfLoc,
            firstname: values.firstName,
            lastname: values.lastName,
            bday: +values.bDay,
            bmonth: +values.bMonth,
            byear: +values.bYear,
            birthday: values.bYear + '-' + values.bMonth + '-' + values.bDay,
            IsIdentifiedAsIndegennous: indigenous,
            MRN: values.mrn,
            reasonForTransport: values.reasonForTransport,
            patientAddress: values.patientAddress,
            genderName: values.sex,
            classificationName: values.acuity,
            mobilityName: ambulant,
            gender: gender,
            classification: !IsNullorEmpty(values.acuity) ? Number(values.acuity) : 0,
            mobility: ambulant === "Ambulant" ? 0 : 1,
            weight: +values.weight,
            estimateWeight: estimateWeight,
            GirthIsOver90CM: grith,
            withAssistance: withAssistance,
            SpecialNeeds: specialNeeds,
            BookingSpecialNeeds: specialValues,
            isOxygenRequired: isOxygenRequired
        }
        return databody;
    }

    const getSpecialNeedId = () => {
        let items = [...specialNeeds];
        let itemArray: any = [];
        items.forEach(item => {
            if (item.selected === true) {
                itemArray.push({
                    SpecialNeedId: item.specialNeedId
                });
            }
        });
        return itemArray;
    }

    const getWeightGirthMessage = (grith: boolean) => {
        let values = getValues();
        let weight = values.weight && /^\d+$/.test(values.weight) ? Number(values.weight) : null;

        if ((weight !== null && (weight < 3 || weight > 200)) || (grith === true)) {
            setWarningMessage("Patient dimensions outside the flags")
        }
        else {
            setWarningMessage("")
        }
    }

    const selectChange = (value: boolean, index: number) => {
        let items = [...specialNeeds];
        let item = { ...items[index] };
        item.selected = value;
        items[index] = item;
        setSpecialNeeds([...items])
    }

    const changeClassificationClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
        window.open('https://www.statemedicalassistance.com.au/nept-scope-of-services/', "_blank");
        e.preventDefault();
    }

    useEffect(() => {
        if ((data.weight < 3 || data.weight > 200) || (data.GirthIsOver90CM == true)) {
            setWarningMessage("Patient dimensions outside the flags")
        }
        else {
            setWarningMessage("")
        }
    }, [data]);

    const onChangepatientOfLocation= (e: any): void=> {
       setClassification('');
       setValue("classificationName", '');
       setValue("acuity", '');
       localStorage.setItem('selectedLocationState', '');
       setisNSWLocationIdb(false)

       if(e?.target?.value != ''){
        setisEnableAcuity(true);
       }
       else{
        setisNSWLocationIdb(null)
        setisEnableAcuity(false);
       }
            
    }

    const IsNullorEmpty= (value: any): boolean=> {
        if(value==null || value == '' || value == undefined){
            return true;
        }
        else{
            return false;
        }
     }

    const getLocationsData = async (showDefault: boolean): Promise<void> => {
        try {
            localStorage.setItem('selectedLocationsId', '');
            const customerLocationsLS = localStorage.getItem('customerLocations');
            let res: SelectItem[] = [];
            if (customerLocationsLS) {
                res = JSON.parse(customerLocationsLS);
            } else {
                const apiData = await api.getCustomerLocations('');
                res = apiData.data.model ?? [];
                localStorage.setItem('customerLocations', JSON.stringify(apiData.data.model));
            }
            const selectedLocations = getDataFromStorage(persistName, "SelectedLocation");     
            if (selectedLocations !== null && selectedLocations !== undefined && selectedLocations.length === 1) {
                res = res.map(l => {
                    return {
                        ...l,
                        selected: l.value === selectedLocations[0]
                    }
                })
                
                setLocationDefaultValue(selectedLocations[0]);
                setClassifications(selectedLocations[0])
                localStorage.setItem('selectedLocationsId', selectedLocations[0]);
            }
            if(localStorage.getItem('SelectedLocation'))
            {
                res = res.map(l => {
                    return {
                        ...l,
                        selected: l.value === localStorage.getItem('SelectedLocation')
                    }
                })
                var selectedloc = localStorage.getItem('SelectedLocation');
                setLocationDefaultValue(selectedloc||"");
                setClassifications(selectedloc)
                localStorage.setItem('selectedLocationsId', String(selectedloc));
            }
            setCustomerLocations(res);
            if (localStorage.getItem('selectedLocationsId') === "" && res.length === 1 && (authStore.data?.IsCustomer || (authStore.data?.location != null && authStore.data?.location.length >0))) {
                const resUserLocation = await api.getLocationsForUserProfiles('');
                if (resUserLocation.data.model.length > 0) {
                    res = res.map(l => {
                        return {
                            ...l,
                            selected: l.value === String(resUserLocation.data.model[0].locationId)
                        }
                    })
                }
                setLocationDefaultValue(resUserLocation.data.model[0].locationId);
                setClassifications(resUserLocation.data.model[0].locationId);
                localStorage.setItem('selectedLocationsId', String(res[0].value));
            }
        }
        catch (error)
        {
            console.error("Error : No date found Patient of Location " + error)
        }
    }

    const dd = React.createRef<HTMLInputElement>();
    const mm = React.createRef<HTMLInputElement>();
    const yyyyy = React.createRef<HTMLInputElement>();

    const loadAcuity =async () => {
        var patientlocation = getValues("patientOfLocation");
        if(patientlocation!=null)
        {
            let customerLocations: any[] = [];
            const res = await api.getLocationsForUserProfiles('');
            customerLocations = res.data.model;
            if (customerLocations) {
                var selectedLocation = customerLocations.filter(a => a.locationId == patientlocation)
                if (selectedLocation != undefined) {
                    if (selectedLocation[0] != undefined) {
                        setSelectedLocaton(selectedLocation[0].state);
                        if (selectedLocation[0].state != null && selectedLocation[0].state != undefined) {
                            localStorage.setItem('selectedLocationState', selectedLocation[0].state);
                            if (selectedLocation[0].state === "NSW") {
                                setisNSWLocationIdb(true);
                                setAcuityPopup(true)
                            }
                            else {
                                setisNSWLocationIdb(false);
                                setAcuityPopup(true)
                            }
                        }
                    }
                }
        }     
        }
        if(isEnableAcuity){
            var state =  localStorage.getItem('selectedLocationState');
            if(state === "NSW"){
                setisNSWLocationIdb(true);
                setAcuityPopup(true)
            }     
            else{
                setisNSWLocationIdb(false);
                setAcuityPopup(true)
            }                
        }
    }
    return (
        <React.Fragment>
            <form onSubmit={handleSubmit(handleNext)} autoComplete="off" id="patientDetailsForm" className={classes.root}>

                <Grid>
                    <Grid  className={classes.fixedTop} container spacing={3} alignItems="flex-start">
                        <Grid item xs={6}>
                            <Typography style={{ fontSize: 36, fontWeight: 900 }}>
                                Patient Details</Typography>
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: 'right' }}>
                            {!isEdit && <NextButton onClick={onNextButtonClick} />}
                            <Button id="update_changes" style={{ display: "none" }} onClick={() => saveChanges(true)}></Button>
                            <Button id="save_changes" style={{ display: "none" }} onClick={() => saveChanges(false)}></Button>
                        </Grid>
                    </Grid>

                    {isSMAProfile && <Grid container spacing={3} style={{paddingTop:110}} alignItems="flex-start">
                        <Grid item xs={6}>
                            <div className={classes.formControlLabel}>Patient of:</div>
                            <Controller
                                name='patientOfLocation'
                                defaultValue=''
                                control={control}
                                render={({ onChange, onBlur, value, name }) => (
                                    <React.Fragment>
                                        <Select
                                            onChange={e => {
                                                onChangepatientOfLocation(e)
                                                onChange(e)
                                                setClassifications(e.target.value)
                                            }}
                                            value={value}
                                            name={name}
                                            IconComponent={KeyboardArrowDownIcon}
                                            fullWidth={true}
                                            classes={{icon:classes.dropdownIcon}}
                                            variant="outlined">
                                            <MenuItem key="None" defaultValue='' value=''>None</MenuItem >
                                            {
                                                customerLocations.filter(item => item.deleted != true).map(item => <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>{item.text}</MenuItem >)
                                            }
                                        </Select>
                                        <FormHelperText className={classes.helpText}>{errors.patientOfLocation ? errors.patientOfLocation.message : ''}</FormHelperText>
                                    </React.Fragment>
                                )}
                                rules={{
                                    validate: (value) => {
                                        if (value === null || value === '') {
                                            return "Location is required"
                                        }
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>}

                    {isSMAProfile && <div style={{ marginTop: 30, marginBottom: 20 }}>
                        <HorizontalLine />
                    </div>}
                
                    <Grid container spacing={3} style={{paddingTop: isSMAProfile ? 0 : 130}} alignItems="flex-start">                                                
                        <Grid item xs={3}>
                            <div className={classes.formControlLabel}>Surname</div>
                            <Controller
                                name='lastName'
                                defaultValue=''
                                control={control}
                                as={<TextField variant='outlined' error={errors.lastName} helperText={errors.lastName ? errors.lastName.message : ""} />}
                                rules={{
                                    required: "Surname is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <div className={classes.formControlLabel}>Given Name</div>
                            <Controller
                                name='firstName'
                                defaultValue=''
                                control={control}
                                as={<TextField variant='outlined' error={errors.firstName} helperText={errors.firstName ? errors.firstName.message : ""} />}
                                rules={{
                                    required: "Given Name is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <div className={classes.formControlLabel}>Date of Birth</div>
                            <Grid container>
                                <Grid item xs="auto">
                                    <div style={{ display: 'inline' }}>
                                        <Controller
                                            name='bDay'
                                            defaultValue=''
                                            control={control}
                                            render={(props) => (
                                                <TextField
                                                    inputRef={dd}
                                                    value={props.value}
                                                    onChange={e => {
                                                        props.onChange(e);
                                                        if (e.target.value.length == 2) {
                                                            mm?.current?.focus();
                                                            return;
                                                        }
                                                    }}
                                                    style={{ padding: 0, margin: 0, maxWidth: 65, minWidth: 65 }}
                                                    placeholder="DD"
                                                    variant='outlined'
                                                    error={errors.bDay}
                                                    inputProps={{ maxLength: 2 }} />
                                            )}
                                            rules={{
                                                maxLength: 2,
                                                required: " ",
                                                pattern: {
                                                    value: consts.NumberRegex,
                                                    message: " "
                                                },
                                                validate: (value) => {
                                                    if (!validateDateOfBirth())
                                                        return false;
                                                    else
                                                        return true;
                                                }
                                            }}
                                        />
                                    </div>
                                    <div style={{ paddingLeft: 5, paddingRight: 5, fontSize: 25, textAlign: 'center', paddingTop: 5, display: 'inline' }}>/</div>
                                </Grid>
                                <Grid item xs="auto">
                                    <div style={{ display: 'inline' }}>
                                        <Controller
                                            name='bMonth'
                                            defaultValue=''
                                            control={control}
                                            render={(props) => (
                                                <TextField
                                                    inputRef={mm}
                                                    value={props.value}
                                                    onChange={e => {
                                                        props.onChange(e);
                                                        if (e.target.value.length == 2) {
                                                            yyyyy?.current?.focus();
                                                            return;
                                                        }
                                                        if (e.target.value.length == 0) {
                                                            dd?.current?.focus();
                                                            return;
                                                        }
                                                    }}
                                                    style={{ padding: 0, margin: 0, maxWidth: 65, minWidth: 65 }}
                                                    placeholder="MM"
                                                    variant='outlined'
                                                    error={errors.bMonth}
                                                    inputProps={{ maxLength: 2 }} />
                                            )}
                                            rules={{
                                                maxLength: 2,
                                                required: " ",
                                                pattern: {
                                                    value: consts.NumberRegex,
                                                    message: " "
                                                },
                                                validate: (value) => {
                                                    if (!validateDateOfBirth())
                                                        return false;
                                                    else
                                                        return true;
                                                }
                                            }}
                                        />
                                    </div>
                                    <div style={{ paddingLeft: 5, paddingRight: 5, fontSize: 25, textAlign: 'center', paddingTop: 5, display: 'inline' }}>/</div>
                                </Grid>
                                <Grid item xs="auto">
                                    <Controller
                                        name='bYear'
                                        defaultValue=''
                                        control={control}
                                        render={(props) => (
                                            <TextField
                                                inputRef={yyyyy}
                                                value={props.value}
                                                onChange={e => {
                                                    props.onChange(e);
                                                    if (e.target.value.length == 0) {
                                                        mm?.current?.focus();
                                                        return;
                                                    }
                                                }}
                                                style={{ padding: 0, margin: 0, maxWidth: 80, minWidth: 80 }}
                                                placeholder="YYYY"
                                                variant='outlined'
                                                error={errors.bYear}
                                                inputProps={{ maxLength: 4, minLength: 4 }} />
                                        )}
                                        rules={{
                                            maxLength: 4,
                                            minLength: 4,
                                            required: " ",
                                            pattern: {
                                                value: consts.NumberRegex,
                                                message: " "
                                            },
                                            validate: (value) => {
                                                if (!validateDateOfBirth())
                                                    return false;
                                                else
                                                    return true;
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            {
                                (errors.bDay || errors.bMonth || errors.bYear) ?
                                    <div style={{ display: 'block' }}>
                                        <FormHelperText className={classes.helpText}>
                                            {(errors.bDay?.type === 'required' || errors.bMonth?.type === 'required' || errors.bYear?.type === 'required') ? 'Date of Birth is required' : 'Date of Birth is invalid'}
                                        </FormHelperText>
                                    </div>
                                    : null
                            }
                        </Grid>
                        <Grid item xs="auto">
                            <div className={classes.formControlLabel}>Sex</div>
                            <Controller
                                render={(props) => (
                                    <RadioGroup row aria-label="position" name="inviteUser" defaultValue="top">
                                        <FormControlLabel
                                            value='Male'
                                            onChange={e => {
                                                setSex('Male');
                                                props.onChange(e)
                                            }}
                                            checked={sex === 'Male' ? true : false}
                                            control={<Radio color="primary" />}
                                            label='Male' />
                                        <FormControlLabel
                                            value='Female'
                                            onChange={e => {
                                                setSex('Female');
                                                props.onChange(e)
                                            }}
                                            checked={sex === 'Female' ? true : false}
                                            control={<Radio color="primary" />}
                                            label='Female' />
                                        <FormControlLabel
                                            value='Not Disclosed'
                                            onChange={e => {
                                                setSex('Not Disclosed');
                                                props.onChange(e)
                                            }}
                                            checked={sex === 'Not Disclosed' ? true : false}
                                            control={<Radio color="primary" />}
                                            label='Not Disclosed' />
                                    </RadioGroup>
                                )}
                                name="sex"
                                control={control}
                                defaultValue=''
                                rules={{
                                    required: "Sex is required",
                                }}
                            />
                            <FormHelperText className={classes.helpText}>{errors.sex ? errors.sex.message : ''}</FormHelperText>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={3}>
                            <div className={classes.formControlLabel}>MRN</div>
                            <Controller
                                name='mrn'
                                defaultValue=''
                                control={control}
                                as={<TextField variant='outlined' error={errors.mrn} helperText={errors.mrn ? errors.mrn.message : ""} />}
                            />
                        </Grid>

                        <Grid style={{ paddingLeft: 50 }} item xs={9}>
                            <div className={classes.formControlLabel}>ABORIGINAL OR TORRES STRAIT ISLANDER?</div>
                            <Controller
                                render={(props) => (
                                    <RadioGroup row aria-label="position" name="inviteUser" defaultValue="top">
                                        <FormControlLabel
                                            value='Neither'
                                            onChange={e => {
                                                setIndigenous('Neither');
                                                props.onChange(e)
                                            }}
                                            checked={indigenous === "Neither" ? true : false}
                                            control={<Radio color="primary" />}
                                            label='Neither' />
                                        <FormControlLabel
                                            value='Aboriginal'
                                            onChange={e => {
                                                setIndigenous('Aboriginal');
                                                props.onChange(e)
                                            }}
                                            checked={indigenous === "Aboriginal" ? true : false}
                                            control={<Radio color="primary" />}
                                            label='Aboriginal' />
                                        <FormControlLabel
                                            value='Torres Strait Islander'
                                            onChange={e => {
                                                setIndigenous('Torres Strait Islander');
                                                props.onChange(e)
                                            }}
                                            checked={indigenous === "Torres Strait Islander" ? true : false}
                                            control={<Radio color="primary" />}
                                            label='Torres Strait Islander' />
                                        <FormControlLabel
                                            value='Both'
                                            onChange={e => {
                                                setIndigenous('Both');
                                                props.onChange(e)
                                            }}
                                            checked={indigenous === "Both" ? true : false}
                                            control={<Radio color="primary" />}
                                            label='Both' />
                                        <FormControlLabel
                                            value='Unspecified'
                                            onChange={e => {
                                                setIndigenous('Unspecified');
                                                props.onChange(e)
                                            }}
                                            checked={indigenous === "Unspecified" ? true : false}
                                            control={<Radio color="primary" />}
                                            label='Unspecified' />
                                    </RadioGroup>
                                )}
                                name="indigenous"
                                control={control}
                                defaultValue=''
                                rules={{
                                    required: "Indigenous is required",
                                }}
                            />
                            <FormHelperText className={classes.helpText}>{errors.indigenous ? errors.indigenous.message : ''}</FormHelperText>
                        </Grid>



                        <Grid item xs={9}>
                            <div className={classes.formControlLabel}>Patient Address</div>
                            <Controller
                                name='patientAddress'
                                defaultValue=''
                                control={control}
                                render={({ onChange, onBlur, value }) => {
                                    return <GooglePlaceAutoComplete placeholder='' onInputChange={(value: string) => {
                                        onChange(value);
                                    }} value={''} inputValue={value} singleLine={true} hideNoOption={true} onBlur={onBlur} error={errors.patientAddress} errorMessage={errors.patientAddress ? errors.patientAddress.message : ''} />
                                }}
                                rules={{
                                    validate: (value) => {
                                        if (value == '') {
                                            return "Patient Address is required"
                                        }
                                    }
                                }}
                            />
                        </Grid>

                    </Grid>
                </Grid>

                <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <HorizontalLine />
                </div>
                <Grid container spacing={3} alignItems="flex-start">
                    <Grid item xs={6}>
                        <div className={classes.formControlLabel}>Acuity</div>
                        <Controller
                            name='acuity'
                            control={control}
                            defaultValue={acuityIdb}
                            render={({ onChange, onBlur, value, name }) => (
                                <React.Fragment>
                                    <Select
                                        name={name}
                                        value={value}
                                        defaultValue={acuityIdb}
                                        IconComponent={KeyboardArrowDownIcon}
                                        displayEmpty
                                        fullWidth={true}
                                        classes={{icon:classes.dropdownIcon}}
                                        variant="outlined"
                                        readOnly
                                        disabled={!isEnableAcuity}
                                        // onClick={() => isEnableAcuity ? setAcuityPopup(true) loadAcuity() : setAcuityPopup(false)}
                                        onClick={() => isEnableAcuity ? loadAcuity(): setAcuityPopup(false)}
                                        onChange={(e: any) => {
                                            onChange(e.target.value)
                                        }}
                                    >
                                        <MenuItem key="None" value="">Choose</MenuItem>
                                        {/* NON-NSW SCALE */}
                                        <MenuItem key={5} value="5">High Acuity</MenuItem>
                                        <MenuItem key={6} value="6">Medium Acuity</MenuItem>
                                        <MenuItem key={7} value="7">Low Acuity</MenuItem>
                                        {/* NSW SCALE */}
                                        <MenuItem key={1} value="1">Class B</MenuItem>
                                        <MenuItem key={2} value="2">Class C</MenuItem>
                                        <MenuItem key={3} value="3">Class D</MenuItem>
                                        <MenuItem key={4} value="4">Class E</MenuItem>
                                    </Select>
                                    {errors.acuity && (
                                        <FormHelperText className={classes.helpText}>{errors.acuity ? errors.acuity.message : ''}</FormHelperText>
                                    )}
                                </React.Fragment>
                            )}
                            rules={{
                                validate: (value) => {
                                    if (value === null || value === '' || value.length === 0) {
                                        return "Acuity is required"
                                    }
                                }
                            }}
                        />
                        <AcuityPopup
                            popState={acuityPopup}
                            setPopState={setAcuityPopup}
                            isNSWLocationIdb={isNSWLocationIdb}
                            setValue={setValue}
                        />
                    </Grid>
                </Grid>
                
                <Grid item xs={9} style={{ paddingTop: 12 }}>
                    <div className={classes.formControlLabel}>Reason for Transport</div>
                    <Controller
                                name='reasonForTransport'
                                defaultValue=''
                                control={control}
                                as={<TextField variant='outlined' error={errors.reasonForTransport} helperText={errors.reasonForTransport ? errors.reasonForTransport.message : ""} />}
                                rules={{
                                    required: "Reason for Transport is required",
                                }}
                    />
                </Grid>

                <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <HorizontalLine />
                </div>

                <Grid>
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={6}>
                            <Typography style={{ fontSize: 13, color: '#A19F9F' }}>
                                WEIGHT &amp; GIRTH </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={3}>
                            <div className={classes.formControlLabel}>Weight (kg)</div>
                            <Controller
                                name='weight'
                                defaultValue=''
                                control={control}
                                rules={{
                                    required: "Weight is required",
                                }}
                                render={(props) => (
                                    <TextField
                                        value={props.value}
                                        type="number"
                                        onChange={e => {
                                            props.onChange(e);
                                            getWeightGirthMessage(grith);

                                        }}
                                        variant='outlined'
                                        error={errors.weight} helperText={errors.weight ? errors.weight.message : ""} />
                                )}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                name='estimateweight'
                                defaultValue=''
                                control={control}
                                render={(props) => (
                                    <FormControlLabel
                                        onChange={e => {
                                            setEstimateWeight(!estimateWeight);
                                            setValue('estimateweight', !estimateWeight);
                                            props.onChange(e)
                                        }}
                                        style={{ marginTop: 30 }}
                                        checked={estimateWeight}
                                        control={<Checkbox color="primary" />}
                                        label='Estimated' />
                                )}
                            />
                        </Grid>
                        <Grid style={{ marginLeft: 30 }} item xs>
                            <div className={classes.formControlLabel}>Girth</div>
                            <Controller
                                name='pgrith'
                                defaultValue=''
                                control={control}
                                render={(props) => (
                                    <FormControlLabel
                                        onChange={e => {
                                            setGrith(!grith);
                                            setValue('pgrith', !grith);
                                            
                                            getWeightGirthMessage(!grith);
                                            props.onChange(e)
                                        }}
                                        checked={grith}
                                        control={<Checkbox color="primary" />}
                                        label='Patient girth is over 90cm' />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {(warningMessage === "Patient dimensions outside the flags")
                    ? <div style={{ padding: 10, backgroundColor: '#FAE1A5', borderRadius: 5, fontSize: 14, fontFamily: 'lato', }}>
                        {warningMessage}
                    </div>
                    : null
                }



                <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <HorizontalLine />
                </div>

                <Grid>
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={6}>
                            <Typography style={{ fontSize: 13, color: '#A19F9F' }}>
                                MOBILITY </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} alignItems="flex-start">
                        <Grid item xs={12} style={{ padding: 0, margin: 0 }}>
                            <Controller
                                render={(props) => (
                                    <RadioGroup row aria-label="position" name="ambulantornot" defaultValue="top">
                                        <FormControlLabel
                                            value='Ambulant'
                                            onChange={e => {
                                                setAmbulant('Ambulant');
                                                setValue('mobilityName', 'Ambulant');
                                                props.onChange(e)
                                            }}
                                            control={<div style={{ padding: 0, margin: 0 }}><Radio checked={ambulant === 'Ambulant' ? true : false} color="primary" /><AmbulantIcon /> </div>}
                                            label='' />
                                        <FormControlLabel
                                            value='NotAmbulant'
                                            onChange={e => {
                                                setAmbulant('NotAmbulant');
                                                setWithAssistance(false);
                                                setValue('assistance', false);
                                                setValue('mobilityName', 'NotAmbulant');
                                                props.onChange(e)
                                            }}
                                            control={<div style={{ padding: 0, margin: 0 }}><Radio checked={ambulant === 'NotAmbulant' ? true : false} color="primary" /> <NotAmbulantIcon /> </div>}
                                            label=''
                                            style={{ marginLeft: 20 }} />
                                    </RadioGroup>
                                )}
                                name="mobilityName"
                                control={control}
                                defaultValue=''
                                rules={{
                                    validate: (value) => {
                                        if (!ambulant)
                                            return "Mobility is required";
                                        else
                                            return true;
                                    }
                                }}
                            />
                            <FormHelperText className={classes.helpText}>{errors.mobilityName ? errors.mobilityName.message : ''}</FormHelperText>
                        </Grid>

                        {
                            ambulant === 'Ambulant' ?
                                <Grid style={{ marginLeft: 30 }} item xs={4}>
                                    <Controller
                                        name='assistance'
                                        defaultValue=''
                                        control={control}
                                        render={(props) => (
                                            <FormControlLabel
                                                onChange={e => {
                                                    setWithAssistance(!withAssistance);
                                                    setValue('assistance', !withAssistance);
                                                    props.onChange(e)
                                                }}
                                                checked={withAssistance}
                                                control={<Checkbox disabled={ambulant === 'Ambulant' ? false : true} style={{ padding: 0, paddingLeft: 10 }} color="primary" />}
                                                label='With assistance' />
                                        )}
                                    />
                                </Grid>
                                : null
                        }
                    </Grid>

                    {
                        ambulant === 'Ambulant' ?
                            <Grid container spacing={1} alignItems="flex-start" style={{ marginTop: 5 }}>
                                <Grid item xs={12} style={{ backgroundColor: '#E3F0E9', color: '#4E9E73', fontSize: 14, height: 41 }}>
                                    <div style={{ paddingTop: 6, paddingLeft: 5 }}>To be considered ambulant, patient must be able to climb three stairs</div>
                                </Grid>
                            </Grid>
                            : null
                    }

                </Grid>

                <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <HorizontalLine />
                </div>

                <Grid>
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={6}>
                            <Typography style={{ fontSize: 13, color: '#A19F9F', paddingBottom: 15 }}>
                                SPECIAL NEEDS </Typography>
                        </Grid>
                    </Grid>
                    <Grid style={{ marginBottom: 40, }} container spacing={0} alignItems="flex-start">

                        {specialNeeds.map((need, index) => {
                            return (
                                <Grid item xs={6} key={need.name + index}>
                                    <FormControlLabel
                                        key={need.name + index}
                                        onChange={e => {
                                            selectChange(!need.selected, index);
                                        }}
                                        checked={need?.selected}
                                        control={<Checkbox style={{ padding: 5 }}
                                            color="primary" />}
                                        label={need.name} />
                                </Grid>
                            );
                        })}

                    </Grid>
                </Grid>

            </form>
        </React.Fragment >
    );
}

export default PatientDetails;